module.exports = __webpack_public_path__ + "img/liferecad_logo-bg.71c1049a.svg";